import { RegionType } from '@wix/shoutout-email-model-v3';
import * as cssUtils from '../../utils/css-utils';
import { getContentWidth } from '../../utils/get-message-width';
export const getLinkSection = ({ region, css, composerData, isRtl, }) => {
    if (region.type !== RegionType.Link) {
        throw Error('Link must be passed');
    }
    const { description, images, originalUrl, title, url } = region.data.extracted;
    const rules = [css['so-global-region-link'], css['so-global-region']];
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules);
    const innerPadding = cssUtils.padding(rules);
    const contentWidth = getContentWidth(composerData, css, rules) -
        (innerPadding.left || 0) -
        (innerPadding.right || 0);
    const columnsWidths = cssUtils
        .calculateColumnsProportions(contentWidth, [30, 70], innerPadding, isRtl)
        .map((val) => `${val}%`);
    const imageUrl = images && images[0] && images[0].url;
    return {
        widthsForMediaQueries: columnsWidths,
        title,
        description,
        imageUrl,
        link: url || originalUrl,
        outerPadding: cssUtils.margin(rules),
        innerPadding,
        cssClass: mobileCssClass,
        imageCssClass: cssUtils.getTopPaddingRestrictionCssClass(rules),
        textCssClass: imageUrl
            ? cssUtils.getBottomPaddingRestrictionCssClass(rules)
            : cssUtils.getTopBottomPaddingRestrictionCssClass(rules),
        columnsWidths,
    };
};
//# sourceMappingURL=get-link-section.js.map